import {Feature} from "./feature";
import {Product} from "./product";

export class ProductGroup {
    id: number;
    name: string;
    minDate: string;
    maxDate: string;
    products: Product[];
    features: Feature[];

    constructor(productGroup: any) {
        this.id = productGroup.id;
        this.name = productGroup.name;
        this.minDate = productGroup.max_age;
        this.maxDate = productGroup.min_age;
        this.features = productGroup.features?.map((feature: any) => new Feature(feature));
        this.products = productGroup.products?.map((product: any) => new Product(product))
    }

    priceIsFinal(): boolean {
        return this.products.some((product: Product) => product.final);
    }
}
